export default {
  en: {
    // Digital App
    'digital-app': 'Digital App',
    'fulfillment': 'Fulfillment',
    'scanned-offer': 'Scanned Offer',
    'loyalty': 'Loyalty',
    'gma-delivery': 'GMA Delivery',

    // Digital Usage
    'digital-usage': 'Digital Usage',
    'sales-percentage': '% Sales',

    // Mobile P&L Detail
    'mobile-profit-and-loss-detail': 'Mobile Profit and Loss Detail',

    // Mobile Offer List
    'mobile-offers-list': 'Mobile Offers List',
    'offer-name': 'Offer Name',

    // GMA Selector
    'Delivery': 'Delivery',
    'Delivery-GC': 'Delivery GC',

    // GMA Delivery (shared between GMADelivery + GMADeliveryGC)
    'gma-delivery-gc': 'GMA Delivery GC',
    'note-avoidable-dasher-wait-time-adwt-fees': 'Note: Avoidable Dasher Wait Time (ADWT) fees:',
    'went-into-effect-on-january-3-2023': 'Went into effect on January 3, 2023 and the terms are outlined in your DoorDash contract',
    'went-into-effect-on': 'Went into effect on January 3, 2023 and the terms are outlined in your DoorDash contract',
    'apply-to-doordash-orders-only': 'Apply to DoorDash orders only and are based on your ADWT results from the prior quarter',
    'apply-to-door-dash-orders': 'Apply to DoorDash orders only and are based on your ADWT results from the prior quarter',
    'are-communicated-by-doordash': 'Are communicated by DoorDash via email on a quarterly basis and included in your DoorDash Merchant portal; for GMA Delivery, the applicable fees are listed as your Drive (GMA) Base Fee',
    'are-communicated-by-door-dash': 'Are communicated by DoorDash via email on a quarterly basis and included in your DoorDash Merchant portal; for GMA Delivery, the applicable fees are listed as your Drive (GMA) Base Fee',
    'digital-id': 'Digital ID',
    'gross-sales': 'Gross Sales',
    'total-amount-for-a-delivery-order-including-taxes': 'Total amount for a delivery order including taxes paid excluding tip paid. This is the total amount the customer actually paid for the GC.',
    'net-sales': 'Net Sales',
    'total-amount-charged-for-all-goods-purchased': 'Total amount charged for all goods purchased for a delivery order, excluding taxes paid and tip paid. This is the amount the customer actually paid, excluding taxes paid.',
    'total-tax': 'Total Tax',
    'total-amount-the-customer-paid-for-tax-for-a-delivery-order': 'Total amount the customer paid for tax for a delivery order.',
    'total-amount-the-customer-paid': 'Total amount the customer paid for tax for a delivery order.',
    'food-and-bev-net': 'Food And Bev Net',
    'total-amount-charged-for-all-goods-purchased-excluding-taxes': 'Total amount charged for all goods purchased for a delivery order, excluding taxes paid and total customer delivery fee(deliveryfee + service fee + small order fee). This amount is expressed in local currency, i.e. the currency used in the market. This amount will exclude tip.',
    'food-and-bev-gross': 'Food And Bev Gross',
    'total-amount-charged-for-all-goods-purchased-including-taxes': 'Total amount charged for all goods purchased for a delivery order, including taxes paid and total customer delivery fee(deliveryfee + service fee + small order fee). This amount is expressed in local currency, i.e. the currency used in the market. This amount will exclude tip.',
    'food-and-bev-tax': 'Food And Bev Tax',
    'total-amount-charged-for-taxes-on-goods-purchased': 'Total amount charged for taxes on goods purchased for a delivery order, excluding total customer delivery fee(delivery fee + service fee + small order fee). This amount is expressed in local currency, i.e. the currency used in the market.',
    'customer-net-delivery-fee': 'Customer Net Delivery Fee',
    'customer-gross-delivery-fee': 'Customer Gross Delivery Fee',
    'total-customer-facing-delivery-fees': 'Total Customer facing delivery fees. This is a calculated fee which includes Delivery Fee, Service Fee and small order Fee excluding taxes.',
    'total-customer-facing-delivery-fees-excluding-taxes': 'Total Customer facing delivery fees. This is a calculated fee which includes Delivery Fee, Service Fee and small order Fee excluding taxes.',
    'total-customer-facing-delivery-fees-including-taxes': 'Total Customer facing delivery fees. This is a calculated fee which includes Delivery Fee, Service Fee and small order Fee including taxes.',
    'customer-delivery-fee-tax': 'Customer Delivery Fee Tax',
    'tax-incurred-on-total-customer-facing-delivery-fees': 'Tax incurred on total customer facing delivery fees.',
    'net-delivery-fee': 'Net Delivery Fee',
    'customer-facing-delivery-fee-excluding-taxes': 'Customer facing delivery fee excluding taxes. Restaurant collects a predefined amount on all delivery orders.',
    'gross-delivery-fee': 'Gross Delivery Fee',
    'customer-facing-delivery-fee-including-taxes': 'Customer facing delivery fee including taxes. Restaurant collects a predefined amount on all delivery orders.',
    'delivery-fee-tax': 'Delivery Fee Tax',
    'tax-on-delivery-fee': 'Tax on Delivery Fee',
    'net-service-fee': 'Net Service Fee',
    'this-is-a-variable-service-fee-excluding-taxes': 'This is a variable service fee excluding taxes. Restaurant recoups revenue on a certain percentage on F&B total.',
    'gross-service-fee': 'Gross Service Fee',
    'this-is-a-variable-service-fee-including-taxes': 'This is a variable service fee including taxes. Restaurant recoups revenue on a certain percentage on F&B total.',
    'service-fee-tax': 'Service Fee Tax',
    'tax-on-service-fee': 'Tax on Service Fee',
    'net-small-order-fee': 'Net Small Order Fee',
    'fee-charged-on-a-small-order-excluding-taxes': 'Fee charged on a small order excluding taxes. Restaurant collects a fee when an order subtotal is below a pre-defined amount.',
    'gross-small-order-fee': 'Gross Small Order Fee',
    'fee-charged-on-a-small-order-including-taxes': 'Fee charged on a small order including taxes. Restaurant collects a fee when an order subtotal is below a pre-defined amount.',
    'small-order-fee-tax': 'Small Order Fee Tax',
    'tax-on-small-order-fee-amount': 'Tax on Small Order Fee Amount',
    'net-flat-fee': 'Net Flat Fee',
    'a-flat-fee-charged-by-vendor-including-taxes': 'A flat fee charged by Vendor including taxes. This is a fee charged to the restaurant by the delivery provider and is not charged to the customer.',
    'flat-fee-gross': 'Flat Fee Gross',
    'flat-fee-tax': 'Flat Fee Tax',
    'net-distance-fee': 'Net Distance Fee',
    'a-distance-fee-charged-by-vendor-excluding-taxes': 'A distance fee charged by Vendor excluding taxes. This is a backend fee and is not charged to customer. Might not be applicable to all orders. Usually charged when the customer is outside of 1 mile of the store.',
    'distance-adwt-fee-gross': 'Distance & ADWT Fee Gross',
    'distance-adwt-fee-tax': 'Distance & ADWT Fee Tax',
    'fulfillment-fee-net': 'Fulfillment Fee Net',
    'fulfillment-fee-gross': 'Fulfillment Fee Gross',
    'fulfillment-fee-is-flat-fee-distance': 'Fulfillment fee is flat fee + distance fee excluding taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-excluding-taxes': 'Fulfillment fee is flat fee + distance fee excluding taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-including-taxes': 'Fulfillment fee is flat fee + distance fee including taxes.',
    'fulfillment-fee-tax': 'Fulfillment Fee Tax',
    'tax-on-fulfillment-fee': 'Tax on Fulfillment Fee',
    'adwt-fee': 'ADWT Fee',
    'adwt-fee-description': 'Net Avoidable Dasher Wait Time (ADWT) fee assessed by DoorDash.',
    'end-time': 'End Time',
    'sales': 'Sales',
    'gma-delivery-driver-tips': 'GMA Delivery Driver Tips',
    'this-is-the-amount-that-is-paid-by-the-customer': 'This is the amount that is paid by the customer and given to the courier.',
    'mcdelivery-sales': 'McDelivery Sales +/-',
    'delivery-sales-compared-to-last-year': 'Delivery Sales compared to last year',
    'mcdelivery-gc': 'McDelivery GC +/-',
    'delivery-gc-compared-to-last-year': 'Delivery GC compared to last year',
    'mcdelivery-average-check': 'McDelivery Average Check',
    'average-check-for-delivery-gc-only': 'Average check for Delivery GC only',
    'mcdelivery-of-net-total-sales': 'McDelivery % of Net Total Sales',
    'mcdelivery-of-total-gc': 'McDelivery % of Total GC',
    'delivery-gc-divided-by-total-gc': 'Delivery GC divided by Total GC',
    'cust-refund': 'Cust Refund',
    'vendor-refund': 'Vendor Refund',
    'vendor-split': 'Vendor Split',
    'merch-refund': 'Merch Refund',
    'merch-split': 'Merch Split',
    'cust-tax-refund': 'Cust Tax Refund',
    'refund-tax': 'Refund Tax',
    'refund-prov-sales-tax': 'Refund Prov Sales Tax',
    'refund-harm-sales-tax': 'Refund Harm Sales Tax',
    'refund-provincial-sales-tax': 'Refund Provincial Sales Tax',
    'refund-harmonized-sales-tax': 'Refund Harmonized Sales Tax',
    'refund-reason': 'Refund Reason',
    'fb-sales': 'F&B Sales',
    'fees': 'Fees',
    'refunds': 'Refunds',
    'payouts': 'Payouts',
    'flat-delivery-fee-plus-tax-on-the-fee': 'Flat Delivery Fee Plus Tax on the Fee',
    'tax-on-the-flat-fee': 'Tax on the Flat Fee',
    'fee-plus-tax-of-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Fee Plus Tax of the Avoidable Dasher Wait Time Fee Assessed by DoorDash',
    'tax-on-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Tax on the Avoidable Dasher Wait Time Fee Assessed by DoorDash',
    'amount-refunded-to-customer': 'Amount Refunded to Customer',
    'amount-of-refund-to-customer-from-3rd-party-delivery-vendor': 'Amount of Refund to Customer from 3rd Party Delivery Vendor',
    'proceeds-to-the-3rd-party-delivery-vendor-from-the-transaction': 'Proceeds to the 3rd Party Delivery Vendor from the Transaction',
    'amount-of-refund-to-customer-from-mcdonalds-restaurant': "Amount of Refund to Customer from McDonald's Restaurant",
    'proceeds-to-the-mcdonalds-restaurant-from-the-transaction': "Proceeds to the McDonald's Restaurant from the Transaction",
    'tax-refunded-to-customer': 'Tax Refunded to Customer',

    // NED
    'ned': 'NED',
    'nedByEmployee': 'NED by Employee',
    'national-employee-discount-ned': 'National Employee Discount (NED)',
    'ned-by-employee': 'NED By Employee',

    // Digital Dashboard Widgets
    'digital-app-gc-breakdown': 'Digital App GC Breakdown',
    'by-store': 'By Store',
    'percentage-of-digital-gc': '% of Digital GC',
    'percentage-of-total-gc': '% of Total GC',
    'digital-app-gc-r-d': 'Digital App GC/R/D',
    'average-gc3': 'Average GC3',
    'average-gc': 'Average GC',
    'loyalty-gc-breakdown': 'Loyalty GC Breakdown',
    'percent-of-gc': 'Percent of GC',
    'mop-fulfillment-breakdown': 'MOP Fulfillment Breakdown',
    'guest-count-percentage': 'Guest Count %',
    'guest-counts': 'Guest Counts',
    'digital-app-p-l-breakdown': 'Digital App P&L Breakdown',
    'digital-app-p-l-detail': 'Digital App P&L Detail',
    'f-p-detail': 'F&P Detail',
    'promo-disc-sales-amt': 'Promo & Disc Sales Amt',
    'percentage-sales': '% Sales',
    'average-check': 'Average Check',
    'mop-with-offers': 'MOP W Offers',
    'mop-without-offers': 'MOP W/O Offers',
    'loyalty-self-id': 'Loyalty Self ID',
    'loyalty-self-id-earned': 'Loyalty Self ID Earned',
    'loyalty-self-id-sales': 'Loyalty Self ID Sales',
    'loyalty-self-id-gcs': "Loyalty Self ID GC's",
    'loyalty-self-id-avg-check': 'Loyalty Self ID Average Check',
    'loyalty-self-id-grd': 'Loyalty Self ID G/R/D',
    'loyalty-self-id-earned-sales': 'Loyalty Self ID Earned Sales',
    'loyalty-self-id-earned-gcs': "Loyalty Self ID Earned GC's",
    'loyalty-self-id-earned-avg-check': 'Loyalty Self ID Earned Average Check',
    'gc': 'GC',
    'gc-pct': 'GC %',
    'mop': 'MOP',
  },
  es: {
    'digital-app': 'Aplicación digital',
    'fulfillment': 'Cumplimiento',
    'scanned-offer': 'Oferta Escaneada',
    'loyalty': 'Lealtad',
    'gma-delivery': 'Entrega GMA',

    'digital-usage': 'Uso digital',
    'sales-percentage': 'Porcentaje de Ventas',

    'mobile-profit-and-loss-detail': 'Detalle de Pérdidas y Ganancias Móviles',

    'mobile-offers-list': 'Lista de Ofertas Móviles',
    'offer-name': 'Nombre de la Oferta',

    'Delivery': 'Entrega',
    'Delivery-GC': 'Entrega GC',

    'gma-delivery-gc': 'Entrega de GMA GC',
    'note-avoidable-dasher-wait-time-adwt-fees': 'Nota: Tarifas por tiempo de espera evitable del Dasher:',
    'went-into-effect-on-january-3-2023': 'Entró en vigencia el 3 de enero de 2023 y los términos están detallados en su contrato con DoorDash.',
    'went-into-effect-on': 'Entró en vigencia el 3 de enero de 2023 y los términos están detallados en su contrato con DoorDash.',
    'apply-to-doordash-orders-only': 'Se aplican solo a los pedidos de DoorDash y se basan en sus resultados de ADWT del trimestre anterior.',
    'apply-to-door-dash-orders': 'Se aplican solo a los pedidos de DoorDash y se basan en sus resultados de ADWT del trimestre anterior.',
    'are-communicated-by-doordash': 'Son comunicadas por DoorDash por correo electrónico trimestralmente y están disponibles en su portal de comerciante de DoorDash; para la Entrega GMA, las tarifas aplicables se enumeran como su tarifa base de Drive (GMA).',
    'are-communicated-by-door-dash': 'Son comunicadas por DoorDash por correo electrónico trimestralmente y están disponibles en su portal de comerciante de DoorDash; para la Entrega GMA, las tarifas aplicables se enumeran como su tarifa base de Drive (GMA).',
    'digital-id': 'ID digital',
    'gross-sales': 'Ventas Brutas',
    'total-amount-for-a-delivery-order-including-taxes': 'Monto total de un pedido de entrega, incluidos los impuestos pagados, excluyendo la propina. Este es el monto total que el cliente realmente pagó por el Conteo de Clientes.',
    'net-sales': 'Ventas Netas',
    'total-amount-charged-for-all-goods-purchased': 'Monto total cobrado por todos los bienes adquiridos en un pedido de entrega, excluyendo impuestos pagados y propina. Es el monto real pagado por el cliente, sin impuestos.',
    'total-tax': 'Impuesto Total',
    'total-amount-the-customer-paid-for-tax-for-a-delivery-order': 'Monto total que el cliente pagó en concepto de impuestos por un pedido de entrega.',
    'total-amount-the-customer-paid': 'Monto total que el cliente pagó en concepto de impuestos por un pedido de entrega.',
    'food-and-bev-net': 'Alimentos y Bebidas Neto',
    'total-amount-charged-for-all-goods-purchased-excluding-taxes': 'Monto total cobrado por todos los bienes adquiridos en un pedido de entrega, excluyendo impuestos y tarifas de entrega del cliente (tarifa de entrega + de servicio + de pedido pequeño). Excluye la propina.',
    'food-and-bev-gross': 'Alimentos y Bebidas Bruto',
    'total-amount-charged-for-all-goods-purchased-including-taxes': 'Monto total cobrado por todos los bienes adquiridos en un pedido de entrega, incluidos los impuestos y las tarifas de entrega del cliente. Excluye la propina.',
    'food-and-bev-tax': 'Impuesto de Alimentos y Bebidas',
    'total-amount-charged-for-taxes-on-goods-purchased': 'Monto total cobrado en impuestos sobre bienes adquiridos, excluyendo tarifas de entrega. Expresado en moneda local.',
    'customer-net-delivery-fee': 'Tarifa de Entrega Neta del Cliente',
    'customer-gross-delivery-fee': 'Tarifa de Entrega Bruta del Cliente',
    'total-customer-facing-delivery-fees': 'Tarifas totales de entrega al cliente. Incluye tarifa de entrega, de servicio y de pedido pequeño, sin impuestos.',
    'total-customer-facing-delivery-fees-excluding-taxes': 'Tarifas totales de entrega al cliente. Incluye tarifa de entrega, de servicio y de pedido pequeño, sin impuestos.',
    'total-customer-facing-delivery-fees-including-taxes': 'Tarifas totales de entrega al cliente. Incluye tarifa de entrega, de servicio y de pedido pequeño con impuestos.',
    'customer-delivery-fee-tax': 'Impuesto de la Tarifa de Entrega del Cliente',
    'tax-incurred-on-total-customer-facing-delivery-fees': 'Impuestos generados por las tarifas totales de entrega al cliente.',
    'net-delivery-fee': 'Tarifa de Entrega Neta',
    'customer-facing-delivery-fee-excluding-taxes': 'Tarifa de entrega cobrada al cliente, sin incluir impuestos. Monto fijo por pedido de entrega.',
    'gross-delivery-fee': 'Tarifa de Entrega Bruta',
    'customer-facing-delivery-fee-including-taxes': 'Tarifa de entrega al cliente, incluidos impuestos. Monto fijo por pedido.',
    'delivery-fee-tax': 'Impuesto de la Tarifa de Entrega',
    'tax-on-delivery-fee': 'Impuesto sobre la tarifa de entrega',
    'net-service-fee': 'Tarifa de Servicio Neta',
    'this-is-a-variable-service-fee-excluding-taxes': 'Tarifa de servicio variable sin impuestos. El restaurante recupera un porcentaje de las ventas de alimentos y bebidas.',
    'gross-service-fee': 'Tarifa de Servicio Bruta',
    'this-is-a-variable-service-fee-including-taxes': 'Tarifa de servicio variable con impuestos. Se basa en un porcentaje de las ventas de alimentos y bebidas.',
    'service-fee-tax': 'Impuesto de la Tarifa de Servicio',
    'tax-on-service-fee': 'Impuesto sobre la tarifa de servicio',
    'net-small-order-fee': 'Tarifa de Pedido Pequeño Neta',
    'fee-charged-on-a-small-order-excluding-taxes': 'Tarifa aplicada a pedidos pequeños sin impuestos. Se cobra si el subtotal no alcanza un mínimo.',
    'gross-small-order-fee': 'Tarifa de Pedido Pequeño Bruta',
    'fee-charged-on-a-small-order-including-taxes': 'Tarifa aplicada a pedidos pequeños incluyendo impuestos. Se aplica bajo un monto mínimo de pedido.',
    'small-order-fee-tax': 'Impuesto de la Tarifa de Pedido Pequeño',
    'tax-on-small-order-fee-amount': 'Impuesto sobre la tarifa de pedido pequeño',
    'net-flat-fee': 'Tarifa Plana Neta',
    'a-flat-fee-charged-by-vendor-including-taxes': 'Tarifa plana cobrada por el proveedor, con impuestos. No se transfiere al cliente.',
    'flat-fee-gross': 'Tarifa Plana Bruta',
    'flat-fee-tax': 'Impuesto de la Tarifa Plana',
    'net-distance-fee': 'Tarifa de Distancia Neta',
    'a-distance-fee-charged-by-vendor-excluding-taxes': 'Tarifa de distancia cobrada por el proveedor, sin impuestos. No siempre aplica. Se suele cobrar si el cliente está a más de 1 milla.',
    'distance-adwt-fee-gross': 'Tarifa de Distancia y ADWT Bruta',
    'distance-adwt-fee-tax': 'Impuesto de la Tarifa de Distancia y ADWT',
    'fulfillment-fee-net': 'Tarifa de Cumplimiento Neta',
    'fulfillment-fee-gross': 'Tarifa de Cumplimiento Bruta',
    'fulfillment-fee-is-flat-fee-distance': 'La tarifa de cumplimiento incluye tarifa plana más tarifa de distancia, sin impuestos.',
    'fulfillment-fee-is-flat-fee-distance-fee-excluding-taxes': 'La tarifa de cumplimiento es la tarifa plana + la tarifa de distancia excluyendo impuestos.',
    'fulfillment-fee-is-flat-fee-distance-fee-including-taxes': 'La tarifa de cumplimiento es la tarifa plana + la tarifa de distancia incluyendo impuestos.',
    'fulfillment-fee-tax': 'Impuesto de la Tarifa de Cumplimiento',
    'tax-on-fulfillment-fee': 'Impuesto sobre la tarifa de cumplimiento',
    'adwt-fee': 'Tarifa ADWT',
    'adwt-fee-description': 'Tarifa neta por tiempo de espera evitable del Dasher (ADWT) cobrada por DoorDash.',
    'end-time': 'Hora de finalización',
    'sales': 'Ventas',
    'gma-delivery-driver-tips': 'Propinas para Conductores de Entrega GMA',
    'this-is-the-amount-that-is-paid-by-the-customer': 'Monto pagado por el cliente y entregado al conductor.',
    'mcdelivery-sales': 'Ventas de McDelivery +/-',
    'delivery-sales-compared-to-last-year': 'Ventas de entrega comparadas con el año pasado',
    'mcdelivery-gc': 'Conteo de Clientes McDelivery +/-',
    'delivery-gc-compared-to-last-year': 'Conteo de Clientes de entrega comparado con el año pasado',
    'mcdelivery-average-check': 'Cheque Promedio de McDelivery',
    'average-check-for-delivery-gc-only': 'Cheque promedio solo para Conteo de Clientes de McDelivery',
    'mcdelivery-of-net-total-sales': '% de McDelivery sobre las Ventas Netas Totales',
    'mcdelivery-of-total-gc': '% de McDelivery sobre el Conteo Total de Clientes',
    'delivery-gc-divided-by-total-gc': 'Conteo de Clientes de entrega dividido por el total',
    'cust-refund': 'Reembolso al Cliente',
    'vendor-refund': 'Reembolso del Proveedor',
    'vendor-split': 'Participación del Proveedor',
    'merch-refund': 'Reembolso de Mercancía',
    'merch-split': 'Participación de Mercancía',
    'cust-tax-refund': 'Reembolso de Impuestos al Cliente',
    'refund-tax': 'Impuesto del Reembolso',
    'refund-prov-sales-tax': 'Impuesto de Ventas Reembolsado del Proveedor',
    'refund-harm-sales-tax': 'Impuesto de Ventas Reembolsado por Daño',
    'refund-provincial-sales-tax': 'Impuesto provincial sobre las ventas de reembolso',
    'refund-harmonized-sales-tax': 'Impuesto armonizado sobre las ventas de reembolso',
    'refund-reason': 'Razón del reembolso',
    'fb-sales': 'Ventas de Alimentos y Bebidas',
    'fees': 'Tarifas',
    'refunds': 'Reembolsos',
    'payouts': 'Pagos',
    'flat-delivery-fee-plus-tax-on-the-fee': 'Tarifa Plana de Entrega más Impuesto',
    'tax-on-the-flat-fee': 'Impuesto sobre la Tarifa Plana',
    'fee-plus-tax-of-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Tarifa más impuesto por tiempo de espera evitable evaluado por DoorDash',
    'tax-on-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Impuesto sobre la tarifa por tiempo de espera evitable evaluado por DoorDash',
    'amount-refunded-to-customer': 'Monto Reembolsado al Cliente',
    'amount-of-refund-to-customer-from-3rd-party-delivery-vendor': 'Reembolso al Cliente desde un Proveedor de Entrega de Terceros',
    'proceeds-to-the-3rd-party-delivery-vendor-from-the-transaction': 'Ganancia del Proveedor de Entrega de Terceros en la Transacción',
    'amount-of-refund-to-customer-from-mcdonalds-restaurant': "Reembolso al Cliente desde el Restaurante McDonald's",
    'proceeds-to-the-mcdonalds-restaurant-from-the-transaction': "Ganancia del Restaurante McDonald's en la Transacción",
    'tax-refunded-to-customer': 'Impuesto Reembolsado al Cliente',

    'ned': 'NED',
    'nedByEmployee': 'NED por Empleado',
    'national-employee-discount-ned': 'Descuento Nacional para Empleados (NED)',
    'ned-by-employee': 'NED Por Empleado',

    'digital-app-gc-breakdown': 'Desglose de GC de la aplicación digital',
    'by-store': 'Por Tienda',
    'percentage-of-digital-gc': '% de GC Digital',
    'percentage-of-total-gc': '% de GC Total',
    'digital-app-gc-r-d': 'GC/R/D de la Aplicación Digital',
    'average-gc3': 'GC3 Promedio',
    'average-gc': 'GC Promedio',
    'loyalty-gc-breakdown': 'Desglose de GC de Lealtad',
    'percent-of-gc': 'Porcentaje de GC',
    'mop-fulfillment-breakdown': 'Desglose de Cumplimiento de MOP',
    'guest-count-percentage': '% de Recuento de Invitados',
    'guest-counts': 'Recuento de Invitados',
    'digital-app-p-l-breakdown': 'Desglose de P&L de la Aplicación Digital',
    'digital-app-p-l-detail': 'Detalle de P&L de la Aplicación Digital',
    'f-p-detail': 'Detalle de F&P',
    'promo-disc-sales-amt': 'Monto de Ventas de Promo y Desc',
    'percentage-sales': '% de Ventas',
    'average-check': 'Promedio de Comprobación',
    'mop-with-offers': 'MOP Con Ofertas',
    'mop-without-offers': 'MOP Sin Ofertas',
    'loyalty-self-id': 'Identificación de Auto Lealtad',
    'loyalty-self-id-earned': 'Lealtad Propia ID Ganada',
    'loyalty-self-id-sales': 'Ventas de Auto Lealtad ID',
    'loyalty-self-id-gcs': "Conteo de Visitantes de Auto Lealtad ID",
    'loyalty-self-id-avg-check': 'Cheque Promedio de Auto Lealtad ID',
    'loyalty-self-id-grd': 'Auto Lealtad ID G/R/D',
    'loyalty-self-id-earned-sales': 'Ventas Ganadas de Auto Lealtad ID',
    'loyalty-self-id-earned-gcs': "Conteo de Visitantes Ganados de Auto Lealtad ID",
    'loyalty-self-id-earned-avg-check': 'Cheque Promedio Ganado de Auto Lealtad ID',
    'gc': 'GC',
    'gc-pct': 'GC %',
    'mop': 'MOP',
  },
  fr: {
    // Digital App
    'digital-app': 'Application mobile',
    'fulfillment': 'Exécution des commandes',
    'scanned-offer': 'Offre scannée',
    'loyalty': 'Fidélité',
    'gma-delivery': 'Livraison GMA',

    // Digital Usage
    'digital-usage': 'Usage digital',
    'sales-percentage': '% des ventes',

    // Mobile P&L Detail
    'mobile-profit-and-loss-detail': 'Détail du compte de résultat mobile',

    // Mobile Offer List
    'mobile-offers-list': 'Liste des offres mobiles',
    'offer-name': 'Nom de l’offre',

    // GMA Selector
    'Delivery': 'Livraison',
    'Delivery-GC': 'GC livraison',

    // GMA Delivery (shared between GMADelivery + GMADeliveryGC)
    'gma-delivery-gc': 'GC livraison GMA',
    'note-avoidable-dasher-wait-time-adwt-fees': 'Remarque : frais d’attente évitable du livreur (ADWT) :',
    'went-into-effect-on-january-3-2023': 'Entrés en vigueur le 3 janvier 2023 ; les conditions sont détaillées dans votre contrat DoorDash',
    'went-into-effect-on': 'Entrés en vigueur le 3 janvier 2023 ; les conditions sont détaillées dans votre contrat DoorDash',
    'apply-to-doordash-orders-only': 'S’appliquent uniquement aux commandes DoorDash et reposent sur vos résultats ADWT du trimestre précédent',
    'apply-to-door-dash-orders': 'S’appliquent uniquement aux commandes DoorDash et reposent sur vos résultats ADWT du trimestre précédent',
    'are-communicated-by-doordash': 'Sont communiqués par DoorDash par e-mail chaque trimestre et figurent dans votre portail marchand DoorDash ; pour la livraison GMA, les frais applicables apparaissent sous l’intitulé Drive (GMA) Base Fee',
    'are-communicated-by-door-dash': 'Sont communiqués par DoorDash par e-mail chaque trimestre et figurent dans votre portail marchand DoorDash ; pour la livraison GMA, les frais applicables apparaissent sous l’intitulé Drive (GMA) Base Fee',
    'digital-id': 'Identifiant digital',
    'gross-sales': 'Ventes brutes',
    'total-amount-for-a-delivery-order-including-taxes': 'Montant total d’une commande en livraison, taxes comprises et hors pourboire. Il s’agit du montant réellement payé par le client pour le GC.',
    'net-sales': 'Ventes nettes',
    'total-amount-charged-for-all-goods-purchased': 'Montant total facturé pour l’ensemble des produits achetés sur une commande en livraison, hors taxes et hors pourboire. Il s’agit du montant réellement payé par le client, hors taxes.',
    'total-tax': 'Total des taxes',
    'total-amount-the-customer-paid-for-tax-for-a-delivery-order': 'Montant total de taxes payé par le client sur une commande en livraison.',
    'total-amount-the-customer-paid': 'Montant total de taxes payé par le client sur une commande en livraison.',
    'food-and-bev-net': 'Net produits et boissons',
    'total-amount-charged-for-all-goods-purchased-excluding-taxes': 'Montant total facturé pour l’ensemble des produits achetés sur une commande en livraison, hors taxes et hors total des frais de livraison client (frais de livraison + frais de service + frais petite commande). Ce montant est exprimé en devise locale, c’est-à-dire celle du marché. Le pourboire en est exclu.',
    'food-and-bev-gross': 'Brut produits et boissons',
    'total-amount-charged-for-all-goods-purchased-including-taxes': 'Montant total facturé pour l’ensemble des produits achetés sur une commande en livraison, taxes comprises et total des frais de livraison client inclus (frais de livraison + frais de service + frais petite commande). Ce montant est exprimé en devise locale, c’est-à-dire celle du marché. Le pourboire en est exclu.',
    'food-and-bev-tax': 'Taxes produits et boissons',
    'total-amount-charged-for-taxes-on-goods-purchased': 'Montant total facturé au titre des taxes sur les produits achetés sur une commande en livraison, hors total des frais de livraison client (frais de livraison + frais de service + frais petite commande). Ce montant est exprimé en devise locale, c’est-à-dire celle du marché.',
    'customer-net-delivery-fee': 'Frais de livraison client nets',
    'customer-gross-delivery-fee': 'Frais de livraison client bruts',
    'total-customer-facing-delivery-fees': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais petite commande, hors taxes.',
    'total-customer-facing-delivery-fees-excluding-taxes': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais petite commande, hors taxes.',
    'total-customer-facing-delivery-fees-including-taxes': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais petite commande, taxes comprises.',
    'customer-delivery-fee-tax': 'Taxes sur les frais de livraison client',
    'tax-incurred-on-total-customer-facing-delivery-fees': 'Taxes appliquées au total des frais de livraison facturés au client.',
    'net-delivery-fee': 'Frais de livraison nets',
    'customer-facing-delivery-fee-excluding-taxes': 'Frais de livraison facturés au client, hors taxes. Le restaurant perçoit un montant prédéfini sur toutes les commandes en livraison.',
    'gross-delivery-fee': 'Frais de livraison bruts',
    'customer-facing-delivery-fee-including-taxes': 'Frais de livraison facturés au client, taxes comprises. Le restaurant perçoit un montant prédéfini sur toutes les commandes en livraison.',
    'delivery-fee-tax': 'Taxes sur les frais de livraison',
    'tax-on-delivery-fee': 'Taxes sur les frais de livraison',
    'net-service-fee': 'Frais de service nets',
    'this-is-a-variable-service-fee-excluding-taxes': 'Il s’agit de frais de service variables, hors taxes. Le restaurant récupère un certain pourcentage du total produits et boissons.',
    'gross-service-fee': 'Frais de service bruts',
    'this-is-a-variable-service-fee-including-taxes': 'Il s’agit de frais de service variables, taxes comprises. Le restaurant récupère un certain pourcentage du total produits et boissons.',
    'service-fee-tax': 'Taxes sur les frais de service',
    'tax-on-service-fee': 'Taxes sur les frais de service',
    'net-small-order-fee': 'Frais petite commande nets',
    'fee-charged-on-a-small-order-excluding-taxes': 'Frais facturés sur une petite commande, hors taxes. Le restaurant perçoit des frais lorsque le sous-total d’une commande est inférieur à un montant prédéfini.',
    'gross-small-order-fee': 'Frais petite commande bruts',
    'fee-charged-on-a-small-order-including-taxes': 'Frais facturés sur une petite commande, taxes comprises. Le restaurant perçoit des frais lorsque le sous-total d’une commande est inférieur à un montant prédéfini.',
    'small-order-fee-tax': 'Taxes sur les frais petite commande',
    'tax-on-small-order-fee-amount': 'Taxes sur le montant des frais petite commande',
    'net-flat-fee': 'Frais forfaitaires nets',
    'a-flat-fee-charged-by-vendor-including-taxes': 'Frais forfaitaires facturés par le prestataire, taxes comprises. Ces frais sont facturés au restaurant par le prestataire de livraison et ne sont pas répercutés sur le client.',
    'flat-fee-gross': 'Frais forfaitaires bruts',
    'flat-fee-tax': 'Taxes sur les frais forfaitaires',
    'net-distance-fee': 'Frais de distance nets',
    'a-distance-fee-charged-by-vendor-excluding-taxes': 'Frais de distance facturés par le prestataire, hors taxes. Il s’agit de frais internes non répercutés sur le client. Ils peuvent ne pas s’appliquer à toutes les commandes. Ils sont généralement facturés lorsque le client se trouve à plus de 1,6 km du restaurant.',
    'distance-adwt-fee-gross': 'Frais de distance et ADWT bruts',
    'distance-adwt-fee-tax': 'Taxes sur les frais de distance et ADWT',
    'fulfillment-fee-net': 'Frais d’exécution nets',
    'fulfillment-fee-gross': 'Frais d’exécution bruts',
    'fulfillment-fee-is-flat-fee-distance': 'Les frais d’exécution correspondent aux frais forfaitaires + frais de distance, hors taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-excluding-taxes': 'Les frais d’exécution correspondent aux frais forfaitaires + frais de distance, hors taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-including-taxes': 'Les frais d’exécution correspondent aux frais forfaitaires + frais de distance, taxes comprises.',
    'fulfillment-fee-tax': 'Taxes sur les frais d’exécution',
    'tax-on-fulfillment-fee': 'Taxes sur les frais d’exécution',
    'adwt-fee': 'Frais ADWT',
    'adwt-fee-description': 'Frais nets d’attente évitable du livreur (ADWT) facturés par DoorDash.',
    'end-time': 'Heure de fin',
    'sales': 'Ventes',
    'gma-delivery-driver-tips': 'Pourboires livreurs GMA',
    'this-is-the-amount-that-is-paid-by-the-customer': 'Il s’agit du montant payé par le client et reversé au livreur.',
    'mcdelivery-sales': 'Ventes McDelivery +/-',
    'delivery-sales-compared-to-last-year': 'Ventes en livraison comparées à l’an dernier',
    'mcdelivery-gc': 'GC McDelivery +/-',
    'delivery-gc-compared-to-last-year': 'GC livraison comparé à l’an dernier',
    'mcdelivery-average-check': 'Ticket moyen McDelivery',
    'average-check-for-delivery-gc-only': 'Ticket moyen pour le GC livraison uniquement',
    'mcdelivery-of-net-total-sales': 'McDelivery en % des ventes nettes totales',
    'mcdelivery-of-total-gc': 'McDelivery en % du GC total',
    'delivery-gc-divided-by-total-gc': 'GC livraison divisé par le GC total',
    'cust-refund': 'Remb. client',
    'vendor-refund': 'Remb. prestataire',
    'vendor-split': 'Quote-part prestataire',
    'merch-refund': 'Remb. commerçant',
    'merch-split': 'Quote-part commerçant',
    'cust-tax-refund': 'Remb. taxes client',
    'refund-tax': 'Taxes sur remboursement',
    'refund-prov-sales-tax': 'Remb. taxe de vente prov.',
    'refund-harm-sales-tax': 'Remb. taxe de vente harm.',
    'refund-provincial-sales-tax': 'Remboursement de la taxe de vente provinciale',
    'refund-harmonized-sales-tax': 'Remboursement de la taxe de vente harmonisée',
    'refund-reason': 'Motif du remboursement',
    'fb-sales': 'Ventes produits et boissons',
    'fees': 'Frais',
    'refunds': 'Remboursements',
    'payouts': 'Versements',
    'flat-delivery-fee-plus-tax-on-the-fee': 'Frais de livraison forfaitaires plus taxes sur ces frais',
    'tax-on-the-flat-fee': 'Taxes sur les frais forfaitaires',
    'fee-plus-tax-of-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Frais et taxes au titre des frais d’attente évitable du livreur facturés par DoorDash',
    'tax-on-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Taxes sur les frais d’attente évitable du livreur facturés par DoorDash',
    'amount-refunded-to-customer': 'Montant remboursé au client',
    'amount-of-refund-to-customer-from-3rd-party-delivery-vendor': 'Montant remboursé au client par le prestataire de livraison tiers',
    'proceeds-to-the-3rd-party-delivery-vendor-from-the-transaction': 'Produit de la transaction revenant au prestataire de livraison tiers',
    'amount-of-refund-to-customer-from-mcdonalds-restaurant': 'Montant remboursé au client par le restaurant McDonald’s',
    'proceeds-to-the-mcdonalds-restaurant-from-the-transaction': 'Produit de la transaction revenant au restaurant McDonald’s',
    'tax-refunded-to-customer': 'Taxes remboursées au client',

    // NED
    'ned': 'NED',
    'nedByEmployee': 'NED par employé',
    'national-employee-discount-ned': 'Remise nationale employés (NED)',
    'ned-by-employee': 'NED par employé',

    // Digital Dashboard Widgets
    'digital-app-gc-breakdown': 'Répartition du GC application mobile',
    'by-store': 'Par restaurant',
    'percentage-of-digital-gc': '% du GC digital',
    'percentage-of-total-gc': '% du GC total',
    'digital-app-gc-r-d': 'GC/R/J application mobile',
    'average-gc3': 'GC3 moyen',
    'average-gc': 'GC moyen',
    'loyalty-gc-breakdown': 'Répartition du GC fidélité',
    'percent-of-gc': 'Pourcentage du GC',
    'mop-fulfillment-breakdown': 'Répartition de l’exécution MOP',
    'guest-count-percentage': '% nombre de clients',
    'guest-counts': 'Nombre de clients',
    'digital-app-p-l-breakdown': 'Répartition du compte de résultat application mobile',
    'digital-app-p-l-detail': 'Détail du compte de résultat application mobile',
    'f-p-detail': 'Détail matières et papier',
    'promo-disc-sales-amt': 'Mnt ventes promos et remises',
    'percentage-sales': '% des ventes',
    'average-check': 'Ticket moyen',
    'mop-with-offers': 'MOP avec offres',
    'mop-without-offers': 'MOP sans offres',
    'loyalty-self-id': 'Auto-identification fidélité',
    'loyalty-self-id-earned': 'Auto-identification fidélité acquise',
    'loyalty-self-id-sales': 'Ventes auto-identification fidélité',
    'loyalty-self-id-gcs': 'GC auto-identification fidélité',
    'loyalty-self-id-avg-check': 'Ticket moyen auto-identification fidélité',
    'loyalty-self-id-grd': 'G/R/J auto-identification fidélité',
    'loyalty-self-id-earned-sales': 'Ventes auto-identification fidélité acquise',
    'loyalty-self-id-earned-gcs': 'GC auto-identification fidélité acquise',
    'loyalty-self-id-earned-avg-check': 'Ticket moyen auto-identification fidélité acquise',
    'gc': 'GC',
    'gc-pct': 'GC %',
    'mop': 'MOP',
  },
  'fr-ca': {
    // Digital App
    'digital-app': 'Application mobile',
    'fulfillment': 'Exécution des commandes',
    'scanned-offer': 'Offre numérisée',
    'loyalty': 'Fidélité',
    'gma-delivery': 'Livraison GMA',

    // Digital Usage
    'digital-usage': 'Utilisation numérique',
    'sales-percentage': '% des ventes',

    // Mobile P&L Detail
    'mobile-profit-and-loss-detail': 'Détail des profits et pertes mobiles',

    // Mobile Offer List
    'mobile-offers-list': 'Liste des offres mobiles',
    'offer-name': 'Nom de l’offre',

    // GMA Selector
    'Delivery': 'Livraison',
    'Delivery-GC': 'GC livraison',

    // GMA Delivery (shared between GMADelivery + GMADeliveryGC)
    'gma-delivery-gc': 'GC livraison GMA',
    'note-avoidable-dasher-wait-time-adwt-fees': 'Remarque : frais d’attente évitable du livreur (ADWT) :',
    'went-into-effect-on-january-3-2023': 'Entrés en vigueur le 3 janvier 2023; les modalités sont précisées dans votre contrat DoorDash',
    'went-into-effect-on': 'Entrés en vigueur le 3 janvier 2023; les modalités sont précisées dans votre contrat DoorDash',
    'apply-to-doordash-orders-only': 'S’appliquent uniquement aux commandes DoorDash et sont fondés sur vos résultats ADWT du trimestre précédent',
    'apply-to-door-dash-orders': 'S’appliquent uniquement aux commandes DoorDash et sont fondés sur vos résultats ADWT du trimestre précédent',
    'are-communicated-by-doordash': 'Sont communiqués par DoorDash par courriel chaque trimestre et figurent dans votre portail marchand DoorDash; pour la livraison GMA, les frais applicables apparaissent sous l’intitulé Drive (GMA) Base Fee',
    'are-communicated-by-door-dash': 'Sont communiqués par DoorDash par courriel chaque trimestre et figurent dans votre portail marchand DoorDash; pour la livraison GMA, les frais applicables apparaissent sous l’intitulé Drive (GMA) Base Fee',
    'digital-id': 'Identifiant numérique',
    'gross-sales': 'Ventes brutes',
    'total-amount-for-a-delivery-order-including-taxes': 'Montant total d’une commande en livraison, taxes comprises et excluant le pourboire. Il s’agit du montant réellement payé par le client pour le GC.',
    'net-sales': 'Ventes nettes',
    'total-amount-charged-for-all-goods-purchased': 'Montant total facturé pour l’ensemble des produits achetés dans une commande en livraison, excluant les taxes et le pourboire. Il s’agit du montant réellement payé par le client, excluant les taxes.',
    'total-tax': 'Total des taxes',
    'total-amount-the-customer-paid-for-tax-for-a-delivery-order': 'Montant total de taxes payé par le client pour une commande en livraison.',
    'total-amount-the-customer-paid': 'Montant total de taxes payé par le client pour une commande en livraison.',
    'food-and-bev-net': 'Net aliments et breuvages',
    'total-amount-charged-for-all-goods-purchased-excluding-taxes': 'Montant total facturé pour l’ensemble des produits achetés dans une commande en livraison, excluant les taxes et le total des frais de livraison au client (frais de livraison + frais de service + frais de petite commande). Ce montant est exprimé en devise locale, soit celle du marché. Le pourboire est exclu.',
    'food-and-bev-gross': 'Brut aliments et breuvages',
    'total-amount-charged-for-all-goods-purchased-including-taxes': 'Montant total facturé pour l’ensemble des produits achetés dans une commande en livraison, taxes comprises et incluant le total des frais de livraison au client (frais de livraison + frais de service + frais de petite commande). Ce montant est exprimé en devise locale, soit celle du marché. Le pourboire est exclu.',
    'food-and-bev-tax': 'Taxes aliments et breuvages',
    'total-amount-charged-for-taxes-on-goods-purchased': 'Montant total facturé au titre des taxes sur les produits achetés dans une commande en livraison, excluant le total des frais de livraison au client (frais de livraison + frais de service + frais de petite commande). Ce montant est exprimé en devise locale, soit celle du marché.',
    'customer-net-delivery-fee': 'Frais de livraison nets au client',
    'customer-gross-delivery-fee': 'Frais de livraison bruts au client',
    'total-customer-facing-delivery-fees': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais de petite commande, excluant les taxes.',
    'total-customer-facing-delivery-fees-excluding-taxes': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais de petite commande, excluant les taxes.',
    'total-customer-facing-delivery-fees-including-taxes': 'Total des frais de livraison facturés au client. Il s’agit d’un montant calculé comprenant les frais de livraison, les frais de service et les frais de petite commande, taxes comprises.',
    'customer-delivery-fee-tax': 'Taxes sur les frais de livraison au client',
    'tax-incurred-on-total-customer-facing-delivery-fees': 'Taxes applicables au total des frais de livraison facturés au client.',
    'net-delivery-fee': 'Frais de livraison nets',
    'customer-facing-delivery-fee-excluding-taxes': 'Frais de livraison facturés au client, excluant les taxes. Le restaurant perçoit un montant prédéfini sur toutes les commandes en livraison.',
    'gross-delivery-fee': 'Frais de livraison bruts',
    'customer-facing-delivery-fee-including-taxes': 'Frais de livraison facturés au client, taxes comprises. Le restaurant perçoit un montant prédéfini sur toutes les commandes en livraison.',
    'delivery-fee-tax': 'Taxes sur les frais de livraison',
    'tax-on-delivery-fee': 'Taxes sur les frais de livraison',
    'net-service-fee': 'Frais de service nets',
    'this-is-a-variable-service-fee-excluding-taxes': 'Il s’agit de frais de service variables, excluant les taxes. Le restaurant récupère un certain pourcentage du total des aliments et breuvages.',
    'gross-service-fee': 'Frais de service bruts',
    'this-is-a-variable-service-fee-including-taxes': 'Il s’agit de frais de service variables, taxes comprises. Le restaurant récupère un certain pourcentage du total des aliments et breuvages.',
    'service-fee-tax': 'Taxes sur les frais de service',
    'tax-on-service-fee': 'Taxes sur les frais de service',
    'net-small-order-fee': 'Frais de petite commande nets',
    'fee-charged-on-a-small-order-excluding-taxes': 'Frais facturés sur une petite commande, excluant les taxes. Le restaurant perçoit des frais lorsque le sous-total d’une commande est inférieur à un montant prédéfini.',
    'gross-small-order-fee': 'Frais de petite commande bruts',
    'fee-charged-on-a-small-order-including-taxes': 'Frais facturés sur une petite commande, taxes comprises. Le restaurant perçoit des frais lorsque le sous-total d’une commande est inférieur à un montant prédéfini.',
    'small-order-fee-tax': 'Taxes sur les frais de petite commande',
    'tax-on-small-order-fee-amount': 'Taxes sur le montant des frais de petite commande',
    'net-flat-fee': 'Frais fixes nets',
    'a-flat-fee-charged-by-vendor-including-taxes': 'Frais fixes facturés par le fournisseur, taxes comprises. Ces frais sont facturés au restaurant par le fournisseur de livraison et ne sont pas facturés au client.',
    'flat-fee-gross': 'Frais fixes bruts',
    'flat-fee-tax': 'Taxes sur les frais fixes',
    'net-distance-fee': 'Frais de distance nets',
    'a-distance-fee-charged-by-vendor-excluding-taxes': 'Frais de distance facturés par le fournisseur, excluant les taxes. Il s’agit de frais internes qui ne sont pas facturés au client. Ils peuvent ne pas s’appliquer à toutes les commandes. Ils sont habituellement facturés lorsque le client se trouve à plus de 1,6 km du restaurant.',
    'distance-adwt-fee-gross': 'Frais de distance et ADWT bruts',
    'distance-adwt-fee-tax': 'Taxes sur les frais de distance et ADWT',
    'fulfillment-fee-net': 'Frais d’exécution nets',
    'fulfillment-fee-gross': 'Frais d’exécution bruts',
    'fulfillment-fee-is-flat-fee-distance': 'Les frais d’exécution correspondent aux frais fixes + frais de distance, excluant les taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-excluding-taxes': 'Les frais d’exécution correspondent aux frais fixes + frais de distance, excluant les taxes.',
    'fulfillment-fee-is-flat-fee-distance-fee-including-taxes': 'Les frais d’exécution correspondent aux frais fixes + frais de distance, taxes comprises.',
    'fulfillment-fee-tax': 'Taxes sur les frais d’exécution',
    'tax-on-fulfillment-fee': 'Taxes sur les frais d’exécution',
    'adwt-fee': 'Frais ADWT',
    'adwt-fee-description': 'Frais nets d’attente évitable du livreur (ADWT) facturés par DoorDash.',
    'end-time': 'Heure de fin',
    'sales': 'Ventes',
    'gma-delivery-driver-tips': 'Pourboires des livreurs GMA',
    'this-is-the-amount-that-is-paid-by-the-customer': 'Il s’agit du montant payé par le client et remis au livreur.',
    'mcdelivery-sales': 'Ventes McDelivery +/-',
    'delivery-sales-compared-to-last-year': 'Ventes en livraison comparées à l’an dernier',
    'mcdelivery-gc': 'GC McDelivery +/-',
    'delivery-gc-compared-to-last-year': 'GC livraison comparé à l’an dernier',
    'mcdelivery-average-check': 'Facture moyenne McDelivery',
    'average-check-for-delivery-gc-only': 'Facture moyenne pour le GC livraison seulement',
    'mcdelivery-of-net-total-sales': 'McDelivery en % des ventes nettes totales',
    'mcdelivery-of-total-gc': 'McDelivery en % du GC total',
    'delivery-gc-divided-by-total-gc': 'GC livraison divisé par le GC total',
    'cust-refund': 'Remb. client',
    'vendor-refund': 'Remb. fournisseur',
    'vendor-split': 'Part du fournisseur',
    'merch-refund': 'Remb. marchand',
    'merch-split': 'Part du marchand',
    'cust-tax-refund': 'Remb. taxes client',
    'refund-tax': 'Taxes sur remboursement',
    'refund-prov-sales-tax': 'Remb. TVP',
    'refund-harm-sales-tax': 'Remb. TVH',
    'refund-provincial-sales-tax': 'Remboursement de la taxe de vente provinciale',
    'refund-harmonized-sales-tax': 'Remboursement de la taxe de vente harmonisée',
    'refund-reason': 'Motif du remboursement',
    'fb-sales': 'Ventes aliments et breuvages',
    'fees': 'Frais',
    'refunds': 'Remboursements',
    'payouts': 'Versements',
    'flat-delivery-fee-plus-tax-on-the-fee': 'Frais de livraison fixes plus taxes sur ces frais',
    'tax-on-the-flat-fee': 'Taxes sur les frais fixes',
    'fee-plus-tax-of-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Frais et taxes des frais d’attente évitable du livreur facturés par DoorDash',
    'tax-on-the-avoidable-dasher-wait-time-fee-assessed-by-doordash': 'Taxes sur les frais d’attente évitable du livreur facturés par DoorDash',
    'amount-refunded-to-customer': 'Montant remboursé au client',
    'amount-of-refund-to-customer-from-3rd-party-delivery-vendor': 'Montant remboursé au client par le fournisseur de livraison tiers',
    'proceeds-to-the-3rd-party-delivery-vendor-from-the-transaction': 'Produit de la transaction versé au fournisseur de livraison tiers',
    'amount-of-refund-to-customer-from-mcdonalds-restaurant': 'Montant remboursé au client par le restaurant McDonald’s',
    'proceeds-to-the-mcdonalds-restaurant-from-the-transaction': 'Produit de la transaction versé au restaurant McDonald’s',
    'tax-refunded-to-customer': 'Taxes remboursées au client',

    // NED
    'ned': 'NED',
    'nedByEmployee': 'NED par employé',
    'national-employee-discount-ned': 'Rabais national aux employés (NED)',
    'ned-by-employee': 'NED par employé',

    // Digital Dashboard Widgets
    'digital-app-gc-breakdown': 'Répartition du GC de l’application mobile',
    'by-store': 'Par restaurant',
    'percentage-of-digital-gc': '% du GC numérique',
    'percentage-of-total-gc': '% du GC total',
    'digital-app-gc-r-d': 'GC/R/J de l’application mobile',
    'average-gc3': 'GC3 moyen',
    'average-gc': 'GC moyen',
    'loyalty-gc-breakdown': 'Répartition du GC fidélité',
    'percent-of-gc': 'Pourcentage du GC',
    'mop-fulfillment-breakdown': 'Répartition de l’exécution MOP',
    'guest-count-percentage': '% d’achalandage',
    'guest-counts': 'Achalandage',
    'digital-app-p-l-breakdown': 'Répartition des profits et pertes de l’application mobile',
    'digital-app-p-l-detail': 'Détail des profits et pertes de l’application mobile',
    'f-p-detail': 'Détail aliments et papier',
    'promo-disc-sales-amt': 'Mnt ventes promos et rabais',
    'percentage-sales': '% des ventes',
    'average-check': 'Facture moyenne',
    'mop-with-offers': 'MOP avec offres',
    'mop-without-offers': 'MOP sans offres',
    'loyalty-self-id': 'Auto-identification fidélité',
    'loyalty-self-id-earned': 'Auto-identification fidélité acquise',
    'loyalty-self-id-sales': 'Ventes auto-identification fidélité',
    'loyalty-self-id-gcs': 'GC auto-identification fidélité',
    'loyalty-self-id-avg-check': 'Facture moyenne auto-identification fidélité',
    'loyalty-self-id-grd': 'G/R/J auto-identification fidélité',
    'loyalty-self-id-earned-sales': 'Ventes auto-identification fidélité acquise',
    'loyalty-self-id-earned-gcs': 'GC auto-identification fidélité acquise',
    'loyalty-self-id-earned-avg-check': 'Facture moyenne auto-identification fidélité acquise',
    'gc': 'GC',
    'gc-pct': 'GC %',
    'mop': 'MOP',
  },
};
